import { useContext, useEffect, useState } from "react";
import useLocalStorage from "../../Utility/useLocalStorage";
import Repo from "../../Utility/Repo";
import { Link } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import CardHome from "../../Components/CardHome";

const cards = [
  {
    id: 1,
    titolo: "ISEE",
    descrizione:
      "Potrai visualizzare gli ISEE caricati dai cittadini, verificarne il valore, confermarli o rifiutarli",
    badge: 0,
    link: "/lista_ISEE",
  },
  {
    id: 2,
    titolo: "UTENTI",
    descrizione:
      "Potrai visualizzare tutti gli utenti presenti nella  piattaforma, inserirne nuovi e caricare per loro l'Isee",
    badge: 0,
    link: "/lista_utenti",
  },
  {
    "id": 3,
    "titolo": "TICKET",
    "descrizione": "Potrai visualizzare e gestire i ticket di supporto, monitorare lo stato delle richieste e risolvere eventuali problemi in modo rapido ed efficiente.",
    "badge": 0,
    "link": "/lista_ticket",
  },
  {
    id: 4,
    titolo: "SERVIZI",
    descrizione:
      "Potrai visualizzare tutti i servizi disponibili, aggiungerne di nuovi, modificarli o eliminarli in base alle tue esigenze.",
    badge: 0,
    link: "/servizi",
  },
  {
    id: 5,
    titolo: "BANDI",
    descrizione:
      "Potrai visualizzare tutti i bandi disponibili, inserirne nuovi e filtrarli per servizio",
    badge: 0,
    link: "/lista_bandi",
    last: true,
  },
];

function Home(props) {
  const [ISEEList, setISEEList] = useState();
  const [cardsState, setCardsState] = useState([]);
  const apiToken = useContext(TokenContext);
  const [loadedUser, setLoadedUser] = useState();
  //
  //setCardsState(cards);

  useEffect(() => {
    Repo.getIseeListUploaded(apiToken)
      .then((response) => {
        setISEEList(response.data.length > 0 && response.data.length);
        //console.log("ISEEList: " + response.data.length);

        // setCardsState(cards);

        let el = cards.map((item) => {
          if (item.id === 1) {
            item.badge = response.data.length;
          }
          return;
          item;
        });

        // Set the previous list to the new list
        setCardsState(el);
      })
      .catch((error) => {
        console.log(error);
      });

      Repo.tuttiTicketAperti(apiToken)
      .then((response) => {
        setISEEList(response.data.length > 0 && response.data.length);
        //console.log("ISEEList: " + response.data.length);

        // setCardsState(cards);

        let el = cards.map((item) => {
          if (item.id === 3) {
            item.badge = response.data.length;
          }
          return;
          item;
        });

        // Set the previous list to the new list
        setCardsState(el);
      })
      .catch((error) => {
        console.log(error);
      });


      


      Repo.getUsersLoadedCount(apiToken)
      .then((response) => {
        setLoadedUser(parseInt(response.data));
   //     console.log("setLoadedUser: " + parseInt(response.data));

        // setCardsState(cards);

        if (parseInt(response.data) > 0) {
          let e2 = cards.map((item) => {
            if (item.id === 2) {
              (item.badge = parseInt(response.data)),
                (item.link = "/lista_utenti?loaded=true");
            }
            return;
            item;
          });

          setCardsState(e2);
        }

      //  console.log("setLoadedUser: " + loadedUser);
        // Set the previous list to the new list
      })
      .catch((error) => {
        console.log(error);
      });


  }, []);


  return (
    <>
      <h1>PANNELLO OPERATORE</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Riepilogo delle principali funzioni di{" "}
          <strong>Semplicita Servizi alla Persona</strong>
        </p>
      </div>
      <div className="row">{cards.map(CardHome)}</div>
    </>
  );
}

export default Home;
